import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

@Pipe({
  name: 'dateTime',
})
export class DateTimePipe implements PipeTransform {
  /**
   * Returns the formatted date with abbreviated timezone.
   * Supports both ISO strings and UNIX timestamps.
   * @param value The date value to format (ISO string or UNIX timestamp)
   * @param includeTime Whether to include time in the formatted output
   */
  transform(value: string | number | null | undefined, includeTime = true): string {
    const timezone = 'America/New_York';
    const format = `MM/DD/YYYY${includeTime ? ' hh:mm:ss A z' : ''}`;

    let date;

    if (typeof value === 'number') {
      // Assume UNIX timestamp in seconds
      date = dayjs.unix(value);
    } else if (typeof value === 'string' && dayjs(value).isValid()) {
      date = dayjs(value);
    }

    return date ? date.tz(timezone).format(format) : value?.toString() || '';
  }
}
